/* eslint-disable */

import colors from "../../../../../public/colors";

export default theme => {
    const { mode } = theme.palette
    return {
    bannerOpen: {
        marginTop: '40px'
    },
    boxContainer: {
        border: '1px black',
    },
    button: {
        '&.MuiButton-root': {
            backgroundColor: '#FEDF01',
            borderRadius: '2px',
            boxSizing: 'border-box',
            boxShadow: 'none',
            color: '#003168',
            height: '32px',
            width: '94px',
            padding: '8px 16px'
        }
    },
    magicLinkContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        width: '100%'
    },
    centralLoginBox: {
        backgroundColor: colors[mode].insightCard,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 64px)',  /* Subtract AppBar height */
        flexDirection: 'column'
    },
    heading: {
        color: colors[mode].checkboxBackground,
        fontStyle: 'Regular',
        fontSize: '32px',
        fontWeight: 400,
        letterSpacing: '0px',
        lineHeight: '40px',
        marginTop: '3%',
        textAlign: 'center',
        fontFamily :'RBCDisplay Regular'
    },
    supportText: {
        color: colors[mode].cardDescription,
        fontSize: '0.875rem',
        fontWeight: 400,
        letterSpacing: '0px',
        lineHeight: '24px',
        margin: 0,
        textAlign: 'center'
    },
    sessionTimeoutWrapper: {
        '& > div:nth-child(2)': {
            paddingLeft: '100px',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '0'
            }
        }
    }
}
}
